export const CARD_MODES = {
  PROFILE: 'Profile',
  TIP: 'Tip',
  REVIEW: 'Review',
  CART: 'Cart'
};
